import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  categoryFilter,
  setCategoryFilter,
  interestedFilter,
  setInterestedFilter,
  ratingFilter,
  setRatingFilter,
  applyFilters,
  removeFilters,
  apidata,
}) {
  // Get unique business category names
  const categoryOptions = Array.from(
    new Set(apidata.map((item) => item.business_category?.name))
  ).filter(Boolean);

  // Get unique ratings (from API)
  const ratingOptions = Array.from(
    new Set(apidata.map((item) => item.rating))
  ).filter(Boolean);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* BUSINESS CATEGORY */}
          <Form.Group className="mb-3">
            <Form.Label>Business Category</Form.Label>
            <Form.Select
              value={categoryFilter}
              onChange={(e) => setCategoryFilter(e.target.value)}
            >
              <option value="">All</option>
              {categoryOptions.map((cat, i) => (
                <option key={i} value={cat}>
                  {cat}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* INTERESTED */}
          <Form.Group className="mb-3">
            <Form.Label>Interested</Form.Label>
            <Form.Select
              value={interestedFilter}
              onChange={(e) => setInterestedFilter(e.target.value)}
            >
              <option value="">All</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </Form.Select>
          </Form.Group>

          {/* RATING */}
          <Form.Group>
            <Form.Label>Rating</Form.Label>
            <Form.Select
              value={ratingFilter}
              onChange={(e) => setRatingFilter(e.target.value)}
            >
              <option value="">All</option>
              {ratingOptions.map((r, i) => (
                <option key={i} value={r}>
                  {r}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
